var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.454 4.802-6.41 11.133 1.595 2.802 6.438-11.133-1.624-2.802zM23.83 2h-1.623l-6.41 11.133h1.622l.38.678.416.706 6.41-11.134L23.831 2zm-6.475 0-6.44 11.133h3.22L20.574 2h-3.22zm-.798 12.58H10.09v.003-.001l-3.247 5.614 3.247 5.613h6.466l3.256-5.613h.001l-1.956-3.372-1.3-2.241zm.835 12.646L27.875 9.032l1.624 2.774L18.987 30H7.668L2 20.193 8.94 8.17h3.219L5.218 20.193l4.045 7.033h8.127z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiro);
export default __webpack_public_path__ + "static/media/KIRO.aa901aa417b4c3acc01fc390761ed30c.svg";
export { ForwardRef as ReactComponent };